import { React, useState, useEffect, useContext, Fragment } from "react";
import styles from "./PCMain.module.css";
import axios from "axios";
import { Chart } from "react-google-charts";
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from "react-router-dom";
import Moment from 'moment';
import "moment/locale/ko";
import GridNoRow from '../../../common/GridNoRow';
import { AppContext } from '../../../AppStore';
import { CircularProgress, Fade } from '@mui/material';

const Main = () => {
    const appStore = useContext(AppContext);
    const mainScreenType = String(localStorage.getItem("main_screen_type"));
    const [rowStock, setRowStock] = useState([]);
    const [columnStock, setColumnStock] = useState([
        { field: 'id', headerName: 'item_id', width: 0, headerAlign: 'center' },
        { field: 'item_data', headerName: '품목정보', width: 350, headerAlign: 'center', align:'left' },
        { field: 'dp_stock', headerName: '재고', width: 85, headerAlign: 'center', align:'right' },
        { field: 'dp_use_stock', headerName: '사용가능재고', width: 120, headerAlign: 'center', align:'right' }
    ]);
    const [rowOrder, setRowOrder] = useState([]);
    const [columnOrder, setColumnOrder] = useState([
        { field: 'id', headerName: 'order_id', width: 0, headerAlign: 'center' },
        { field: 'order_data', headerName: '수주정보', width: 550, headerAlign: 'center', align:'left' }
    ]);
    const [rowPurchase, setRowPurchase] = useState([]);
    const [columnPurchase, setColumnPurchase] = useState([
        { field: 'id', headerName: 'purchase_id', width: 0, headerAlign: 'center' },
        { field: 'purchase_data', headerName: '발주정보', width: 550, headerAlign: 'center', align:'left' }
    ]);
    const [rowIncoming, setRowIncoming] = useState([]);
    const [columnIncoming, setColumnIncoming] = useState([
        { field: 'id', headerName: 'incoming_id', width: 0, headerAlign: 'center' },
        { field: 'incoming_data', headerName: '입고정보', width: 550, headerAlign: 'center', align:'left' }
    ]);
    const [rowOutgoing, setRowOutgoing] = useState([]);
    const [columnOutgoing, setColumnOutgoing] = useState([
        { field: 'id', headerName: 'outgoing_id', width: 0, headerAlign: 'center' },
        { field: 'outgoing_data', headerName: '출하정보', width: 550, headerAlign: 'center', align:'left' }
    ]);
    const [rowQualityMeasurement, setRowQualityMeasurement] = useState([]);
    const [columnQualityMeasurement, setColumnQualityMeasurement] = useState([
        { field: 'id', headerName: 'quality_measurement_id', width: 0, headerAlign: 'center' },
        { field: 'quality_measurement_data', headerName: '품질측정정보', width: 550, headerAlign: 'center', align:'left' }
    ]);

    const [machineReady, setMachineReady] = useState('N');
    const [machine, setMachine] = useState([]);
    const navigate = useNavigate();
    const pcDetailRouteMap = {
        order: (id) => `/p/order/${id}`,
        outgoing: (id) => `/p/outgoing/${id}`,
        incoming: (id) => `/p/incoming/${id}`,
        purchase: (id) => `/p/purchase/${id}`,
        quality_measurement: (id) => `/p/quality_measurement/${id}`,
    };
    const handleRowClick = (type) => (params) => {
        const id = params?.row?.id ?? params?.id;
        if (!id) return;
        const buildPath = pcDetailRouteMap[type];
        if (!buildPath) return;
        navigate(buildPath(id));
    };
    const [projectPie, setProjectPie] = useState(
        [[
        ["비율", "프로젝트"],
        [0, ""]
        ],
        [
        ["비율", "프로젝트"],
        [0, ""]
        ]]
    );
    const projectPie_option = {
        title: "프로젝트",
        titleTextStyle: { fontSize: 18, fontName: 'Arial',},
        colors: ["rgb(232, 176, 141)","rgb(206, 141, 232)","rgb(141, 231, 232)", "rgb(232, 141, 141)", "rgb(151, 236, 91)"],
        legend: {position: "right", alignment: "center",textStyle: {color: "#233238",fontSize: 13,},},
    };
    const [runPie, setRunPie] = useState(
        [[
            ["비율", "가동상태"],
            ["가동", 1],
            ["정지", 1],
            ["홀드", 1],
            ["MSRT", 1],
            ["오프라인", 1]
        ],[
            ["비율", "가동상태"],
            ["가동", 1],
            ["정지", 1],
            ["홀드", 1],
            ["MSRT", 1],
            ["오프라인", 1]
        ]]
    );
    const runPie_option = {
        title: "가동상태",
        titleTextStyle: { fontSize: 18, fontName: 'Arial',},
        colors: ["rgb(104, 171, 38)","#D84B16","#FFB737","#F1A7C9", "rgb(57, 54, 54)"],
        legend: {position: "right", alignment: "center",textStyle: {color: "#233238",fontSize: 13,},},
    };
    const [autPie, setAutPie] = useState(
        [[
            ["비율", "가동모드"],
            ["MDI", 1],
            ["MEM", 1],
            ["EDIT", 1],
            ["HND", 1],
            ["JOG", 1],
            ["REF", 1],
            ["ETC", 1],
        ],[
            ["비율", "가동모드"],
            ["MDI", 1],
            ["MEM", 1],
            ["EDIT", 1],
            ["HND", 1],
            ["JOG", 1],
            ["REF", 1],
            ["ETC", 1],
        ]]
    );
    const autPie_option = {
        title: "가동모드",
        titleTextStyle: { fontSize: 18, fontName: 'Arial',},
        colors: ["rgb(245, 123, 123)", "rgb(232, 215, 105)","rgb(128, 236, 104)","rgb(88, 136, 233)", "rgb(212, 95, 239)", "rgb(57, 54, 54)", "rgb(211, 141, 43)"],
        legend: {position: "right", alignment: "center",textStyle: {color: "#233238",fontSize: 13,},},
    };
    const [statusPie, setStatusPie] = useState([]);
    const statusPie_option = {
        title: "가동상태",
        titleTextStyle: { fontSize: 18, fontName: 'Arial',},
        colors: ["rgb(104, 171, 38)","#D84B16"],
        legend: {position: "right", alignment: "center",textStyle: {color: "#233238",fontSize: 13,},},
    };
    const [errorPie, setErrorPie] = useState([]);
    const errorPie_option = {
        title: "불량율",
        titleTextStyle: { fontSize: 18, fontName: 'Arial',},
        colors: ["#2196F3","#F44336"],
        legend: {position: "right", alignment: "center",textStyle: {color: "#233238",fontSize: 13,},},
    };
    const [errorTypePie, setErrorTypePie] = useState([]);
    const errorTypePie_option = {
        title: "불량유형",
        titleTextStyle: { fontSize: 18, fontName: 'Arial',},
        colors: ["#D84B16","#FFB737","rgb(232, 141, 141)"],
        legend: {position: "right", alignment: "center",textStyle: {color: "#233238",fontSize: 12.5,},},
    };
    const [timeLineData, setTimeLineData] = useState([
            [
            { type: "string", id: "Room" },
            { type: "string", id: "Name" },
            { type: "date", id: "Start" },
            { type: "date", id: "End" },
            ],
            [
                "기간",
                "오프라인",
                new Date(0, 0, 0, 0, 0, 0),
                new Date(0, 0, 0, 8, 0, 0),
            ],
            [
                "기간",
                "가동",
                new Date(0, 0, 0, 8, 0, 0),
                new Date(0, 0, 0, 16, 0, 0),
            ],
            [
                "기간",
                "정지",
                new Date(0, 0, 0, 16, 0, 0),
                new Date(0, 0, 0, 24, 0, 0),
            ],
    ]);
    const [timeLineOption, setTimeLineOption] = useState({
        timeline: { showRowLabels: false },
        avoidOverlappingGridLines: false,
        colors: ["#cbb69d", "#603913", "#c69c6e"],
    });
    const [modbusLineData, setModbusLineData] = useState({});

    const formatTime = (timeStr) => {
        if (!timeStr) return '';
        const parts = timeStr.split(':');
        if (parts.length !== 3) return timeStr;
        return `${parts[0]}H ${parts[1]}M ${parts[2]}S`;
    };

    const MainSearch = async () => {
        if (String(mainScreenType) !== '1') return;

        try {
            // 1) 첫 조회
            const resp = await axios.get('/api/p/MachineMonitoring/Select');
            const rows = resp?.data ?? [];
            console.log('/api/p/MachineMonitoring/Select', resp);
            
            // === 가공 결과 컨테이너 ===
            const machineInfo = [];
            const status_array = [];
            const error_array = [];
            const error_type_array = [];

            let hasType1 = false;
            // 2) 행 단위 가공
            console.log(rows);
            for (let i = 0; i < rows.length; i++) {
                const data = rows[i];
                
                if (String(data.machine_type) === '1') hasType1 = true;

                // 공통 임시값
                let temp_percent = 0;
                let temp_percent_color = 'white';

                // run/aut 상태 계산
                const temp_status_run = (data.status_run !== undefined ? data.status_run : data.status);
                let temp_status_run_name = '';
                let temp_status_run_color = 'white';

                const temp_status_aut = data.status_aut;
                let temp_status_aut_name = '';

                // === 타입별 처리 ===
                if (data.machine_type == '1') {
                    // (1) 달성률 색상 계산
                    if (Number(data.sum_produce_count) > 0) {
                        const target = Number(data.target_count) || 0;
                        const produce = Number(data.produce_count) || 0;
                        if (target > 0) temp_percent = Math.floor((produce / target) * 100);

                        if (temp_percent >= 100) {
                            temp_percent = 100;
                            temp_percent_color = 'rgb(90, 150, 70)';   // 안정
                        }
                        if (temp_percent <= 50) {
                            temp_percent_color = 'rgb(200, 80, 80)';   // 위험
                        } else if (temp_percent > 50 && temp_percent <= 80) {
                            temp_percent_color = 'rgb(210, 140, 60)';  // 주의
                        } else if (temp_percent > 80 && temp_percent <= 99) {
                            temp_percent_color = 'rgb(160, 150, 80)';  // 거의 안정
                        }
                    }

                    // (2) 가동상태 이름/색상
                    if (temp_status_run == 0) {
                        temp_status_run_name = '오프라인'; temp_status_run_color = 'rgb(57, 54, 54)';
                    } else if (temp_status_run == 1) {
                        temp_status_run_name = '정지'; temp_status_run_color = '#D84B16';
                    } else if (temp_status_run == 2) {
                        temp_status_run_name = '홀드'; temp_status_run_color = '#FFB737';
                    } else if (temp_status_run == 3) {
                        temp_status_run_name = '가동'; temp_status_run_color = 'rgb(104, 171, 38)';
                    } else if (temp_status_run == 4) {
                        temp_status_run_name = 'MSTR'; temp_status_run_color = '#F1A7C9';
                    } else if (temp_status_run == -1) {
                        temp_status_run_name = '미 연결'; temp_status_run_color = 'rgba(100,116,139,.5)';
                    } else {
                        temp_status_run_name = ''; temp_status_run_color = '#bdbdbd';
                    }

                    // (3) 가동모드 이름
                    if (temp_status_aut == '0') temp_status_aut_name = 'MDI';
                    else if (['10','2','6','7','8'].includes(String(temp_status_aut))) temp_status_aut_name = 'ETC';
                    else if (temp_status_aut == '3') temp_status_aut_name = 'EDIT';
                    else if (temp_status_aut == '4') temp_status_aut_name = 'HND';
                    else if (temp_status_aut == '5') temp_status_aut_name = 'JOG';
                    else if (temp_status_aut == '9') temp_status_aut_name = 'REF';
                    else if (temp_status_aut == '1') temp_status_aut_name = 'MEM';
                    else if (temp_status_aut == -1) temp_status_aut_name = '미 연결';
                    else temp_status_aut_name = '';

                } else if (data.machine_type == '2' || data.machine_type == '4') {
                    // (1) 달성률 색상 계산 (sum_produce_count / target_count)
                    if (Number(data.sum_produce_count) > 0) {
                        const target = Number(data.target_count) || 0;
                        const sumProd = Number(data.sum_produce_count) || 0;
                        if (target > 0) temp_percent = Math.floor((sumProd / target) * 100);

                        if (temp_percent >= 100) {
                            temp_percent = 100;
                            temp_percent_color = 'rgb(90, 150, 70)';   // 안정
                        }
                        if (temp_percent <= 50) {
                            temp_percent_color = 'rgb(200, 80, 80)';   // 위험
                        } else if (temp_percent > 50 && temp_percent <= 80) {
                            temp_percent_color = 'rgb(210, 140, 60)';  // 주의
                        } else if (temp_percent > 80 && temp_percent <= 99) {
                            temp_percent_color = 'rgb(160, 150, 80)';  // 거의 안정
                        }
                    }

                    // (2) 가동상태 이름/색상 (2/4 전용)
                    if (temp_status_run == 0) {
                        temp_status_run_name = '정지'; temp_status_run_color = '#D84B16';
                    } else if (temp_status_run == 1) {
                        temp_status_run_name = '가동'; temp_status_run_color = 'rgb(104, 171, 38)';
                    } else if (temp_status_run == -1) {
                        temp_status_run_name = '미 연결'; temp_status_run_color = 'rgba(100,116,139,.5)';
                    } else {
                        temp_status_run_name = ''; temp_status_run_color = '#bdbdbd';
                    }
                } else if (data.machine_type == '5') {
                    if (temp_status_run == 1) {
                        temp_status_run_name = '가동'; temp_status_run_color = 'rgb(104, 171, 38)';
                    } else if (temp_status_run == 0) {
                        temp_status_run_name = '정지'; temp_status_run_color = '#D84B16';
                    } else if (temp_status_run == -1) {
                        temp_status_run_name = '미 연결'; temp_status_run_color = 'rgba(100,116,139,.5)';
                    } else {
                        temp_status_run_name = ''; temp_status_run_color = '#bdbdbd';
                    }
                }

                // (4) 화면에 쓸 기계 정보 push
                if (['1', '2', '4', '5'].includes(String(data.machine_type))) {
                    machineInfo.push({
                        machine_id: data.machine_id,
                        machine_name: data.machine_name,
                        machine_type: data.machine_type,
                        machine_max_datetime: data.max_datetime,
                        target_count: (typeof data.target_count === 'undefined' ? "0" : data.target_count),
                        produce_count: (typeof data.produce_count === 'undefined' ? "0" : data.produce_count),
                        project_number: (typeof data.project_number === 'undefined' ? "" : data.project_number),
                        project_name: (typeof data.project_name === 'undefined' ? "" : data.project_name),
                        progress_percent: (typeof data.produce_count === 'undefined' && typeof data.sum_produce_count === 'undefined') ? "0" : temp_percent,
                        progress_percent_color: temp_percent_color,
                        run_status: temp_status_run_name,
                        run_color: temp_status_run_color,
                        aut_status: temp_status_aut_name,
                        sum_produce_time: data.sum_produce_time,
                        sum_produce_count: data.sum_produce_count,
                        sum_ok_count: (typeof data.sum_ok_count === 'undefined' ? "0" : data.sum_ok_count),
                        sum_ng_count: (typeof data.sum_ng_count === 'undefined' ? "0" : data.sum_ng_count),
                        ng1_count: (typeof data.ng1_count === 'undefined' ? "0" : data.ng1_count),
                        ng2_count: (typeof data.ng2_count === 'undefined' ? "0" : data.ng2_count),
                        ng3_count: (typeof data.ng3_count === 'undefined' ? "0" : data.ng3_count),
                        ng1_label: (typeof data.ng1_label === 'undefined' ? "" : data.ng1_label),
                        ng2_label: (typeof data.ng2_label === 'undefined' ? "" : data.ng2_label),
                        ng3_label: (typeof data.ng3_label === 'undefined' ? "" : data.ng3_label),
                        raw_total_part: (typeof data.raw_total_part === 'undefined' ? "" : data.raw_total_part),
                        raw_cut_time: (typeof data.raw_cut_time === 'undefined' ? "" : data.raw_cut_time),
                        raw_cycle_time: (typeof data.raw_cycle_time === 'undefined' ? "" : data.raw_cycle_time),
                        raw_general_cut_time: (typeof data.raw_general_cut_time === 'undefined' ? "" : data.raw_general_cut_time),
                        raw_model: (typeof data.raw_model === 'undefined' ? "" : data.raw_model),
                        raw_part: (typeof data.raw_part === 'undefined' ? "" : data.raw_part),
                        raw_run_time: (typeof data.raw_run_time === 'undefined' ? "" : data.raw_run_time),
                        raw_target_part: (typeof data.raw_target_part === 'undefined' ? "" : data.raw_target_part),
                        raw_total_time: (typeof data.raw_total_time === 'undefined' ? "" : data.raw_total_time),
                        raw_type: (typeof data.raw_type === 'undefined' ? "" : data.raw_type),
                        val1: data.val1, val1_name: data.val1_name,
                        val2: data.val2, val2_name: data.val2_name,
                        val3: data.val3, val3_name: data.val3_name,
                        val4: data.val4, val4_name: data.val4_name,
                        val5: data.val5, val5_name: data.val5_name,
                        val6: data.val6, val6_name: data.val6_name,
                        val7: data.val7, val7_name: data.val7_name,
                        val8: data.val8, val8_name: data.val8_name,
                        val9: data.val9, val9_name: data.val9_name,
                    });

                    if(data.machine_type == '2'){
                        // 타임라인 데이터 호출
                        axios.get('/api/p/MachineRuningStatus/TimeLineData',
                            {
                                params : {
                                    id : data.machine_id
                                }
                            },
                            { withCredentials: true }
                        )
                        .then((response2) => {
                            let temp_array = [ // 타임라인 데이터 임시 배열
                                [
                                    { type: "string", id: "Room" },
                                    { type: "string", id: "Name" },
                                    { type: "date", id: "Start" },
                                    { type: "date", id: "End" },
                                ],
                            ]
                            let temp_color_array = [] // 타임라인 색상 임시 배열
                            // 마지막 24시를 위한 임시데이터
                            let last_hour = ''
                            let last_min = ''
                            let last_sec = ''
                            let temp_start_hour = '';
                            let temp_start_min = '';
                            let temp_start_sec = '';
                            let temp_end_hour = '';
                            let temp_end_min = '';
                            let temp_end_sec = '';
                            let temp_status = '';
                            let temp_status_name = '';
                            let temp_status_color = '';

                            let status_0 = 'N';
                            let status_1 = 'N';
                            let status_2 = 'N';
                            let status_3 = 'N';
                            let status_4 = 'N'; 
                            for(let i = 0; i < response2.data.length; i++) {
                                let addYN = 'N';
                                let data = response2.data[i];

                                if(data.status_run !== temp_status){
                                    temp_start_hour = Moment(data.start_datetime).format('HH');
                                    temp_start_min = Moment(data.start_datetime).format('mm');
                                    temp_start_sec = Moment(data.start_datetime).format('ss');
                                }
                                
                                temp_status = data.status_run;
                                
                                if(i === (response2.data).length-1 || temp_status !== (response2.data[i+1]).status_run){
                                    
                                    addYN = 'Y'
                                    temp_end_hour = Moment(data.end_datetime).format('HH');
                                    temp_end_min = Moment(data.end_datetime).format('mm');
                                    temp_end_sec = Moment(data.end_datetime).format('ss');

                                    if(String(data.machine_type) === '1'){
                                        //run 동작상태 # 0 : 오프라인 , 1 : 정지 , 2 : 홀드 , 3 : 가동 , 4 : MSTR
                                        if(Number(temp_status) === 0 || Number(temp_status) === -1){
                                            temp_status_name = '오프라인'
                                            temp_status_color = 'rgb(57, 54, 54)'
                                            if(status_0 === 'N'){
                                                temp_color_array = temp_color_array.concat('rgb(57, 54, 54)')
                                            }
                                            status_0 = 'Y'
                                        } else if (Number(temp_status) === 1){
                                            temp_status_name = '정지'
                                            temp_status_color = '#D84B16'
                                            if(status_1 === 'N'){
                                                temp_color_array = temp_color_array.concat('#D84B16')
                                            }
                                            status_1 = 'Y'
                                        } else if (Number(temp_status) === 2){
                                            temp_status_name = '홀드'
                                            temp_status_color = '#FFB737'
                                            if(status_2 === 'N'){
                                                temp_color_array = temp_color_array.concat('#FFB737')
                                            }
                                            status_2 = 'Y'
                                        } else if (Number(temp_status) === 3){
                                            temp_status_name = '가동'
                                            temp_status_color = 'rgb(104, 171, 38)'
                                            if(status_3 === 'N'){
                                                temp_color_array = temp_color_array.concat('rgb(104, 171, 38)')
                                            }
                                            status_3 = 'Y'
                                        } else if (Number(temp_status) === 4){
                                            temp_status_name = 'MSTR'
                                            temp_status_color = '#F1A7C9'
                                            if(status_4 === 'N'){
                                                temp_color_array = temp_color_array.concat('#F1A7C9')
                                            }
                                            status_4 = 'Y'
                                        }
                                    } else if(String(data.machine_type) === '2' || String(data.machine_type) === '4'){
                                        if (Number(temp_status) === 0 || Number(temp_status) === -1){
                                            temp_status_name = '정지'
                                            temp_status_color = '#D84B16'
                                            if(status_1 === 'N'){
                                                temp_color_array = temp_color_array.concat('#D84B16')
                                            }
                                            status_1 = 'Y'
                                        } else if (Number(temp_status) === 1){
                                            temp_status_name = '가동'
                                            temp_status_color = 'rgb(104, 171, 38)'
                                            if(status_3 === 'N'){
                                                temp_color_array = temp_color_array.concat('rgb(104, 171, 38)')
                                            }
                                            status_3 = 'Y'
                                        }
                                    }
                                }
                                

                                if(addYN === 'Y'){
                                    let temp_data = [[ // 이번에 들어갈 데이터
                                        "기간",
                                        temp_status_name,
                                        new Date(0, 0, 0, temp_start_hour, temp_start_min, temp_start_sec),
                                        new Date(0, 0, 0, temp_end_hour, temp_end_min, temp_end_sec),
                                    ]]
                                    if(temp_start_hour||'$'||temp_start_min||'$'||temp_start_sec !== temp_end_hour||'$'||temp_end_min||'$'||temp_end_sec){
                                        temp_array = temp_array.concat(temp_data)
                                    }
                                }
                            }
                            
                            // 마지막 24시를 위한 임시데이터
                            last_hour = temp_end_hour;
                            last_min = temp_end_min;
                            last_sec = temp_end_sec;
                            let temp_data = [[
                                // 마지막 24시간 데이터 추가
                                "기간",
                                '데이터 수집중',
                                new Date(0, 0, 0, last_hour, last_min, last_sec),
                                new Date(0, 0, 0, 24, 0, 0),
                            ]]
                            temp_array = temp_array.concat(temp_data)
                            temp_color_array = temp_color_array.concat('rgb(255, 255, 255)')
                            
                            setTimeLineOption(
                                {
                                    timeline: { showRowLabels: false },
                                    avoidOverlappingGridLines: false,
                                    colors: temp_color_array,
                                }
                            )
                            setTimeLineData(temp_array)
                        })
                        .catch((error) => {
                            appStore.capture();
                        })
                    }else if(data.machine_type == '5'){
                        axios.get('/api/p/MachineRuningStatus/ModbusTimeData',
                            {
                                params : {
                                    id : data.machine_id
                                }
                            },
                            { withCredentials: true }
                        )
                        .then((response2) => {
                            const list = response2.data || [];
                            if (list.length > 0) {
                                let headers = ["시간"];
                                let validKeys = [];
                                
                                // 1. 🚨 수정됨: 첫 번째 줄을 기준으로 '진짜 이름(라벨)'이 매핑되어 있는 슬롯만 정확히 골라냅니다.
                                const firstRow = list[0];
                                for(let k=1; k<=9; k++) {
                                    if (firstRow[`val${k}_name`] && String(firstRow[`val${k}_name`]).trim() !== "") {
                                        headers.push(firstRow[`val${k}_name`]);
                                        validKeys.push(`val${k}`);
                                    }
                                }
                                
                                // 2. 유효한 데이터가 있을 때만 구글 차트용 배열을 조립합니다.
                                if (validKeys.length > 0) {
                                    let chartData = [headers];
                                    list.forEach(row => {
                                        let rowData = [row.time_str];
                                        validKeys.forEach(k => {
                                            rowData.push(row[k] !== null ? Number(row[k]) : null);
                                        });
                                        chartData.push(rowData);
                                    });

                                    // 기계 ID별로 차트 데이터를 상태에 저장합니다.
                                    setModbusLineData(prev => ({
                                        ...prev,
                                        [data.machine_id]: chartData
                                    }));
                                }
                            }
                        })
                        .catch((error) => {
                            try { appStore?.capture?.(error); } catch {}
                        })
                    }
                    
                    // (5) 파이 차트용 배열들 정렬(인덱스 맞추기)
                    if (data.machine_type == '2' || data.machine_type == '4') {
                        status_array.push([
                            ["상태", "가동율"],
                            ["가동", data.run_min ?? 0],
                            ["정지", data.stop_min ?? 0],
                        ]);
                        error_array.push([
                            ["상태", "불량율"],
                            ["OK", data.sum_ok_count ?? 0],
                            ["NG", data.sum_ng_count ?? 0],
                        ]);
                    } else {
                        status_array.push(null);
                        error_array.push(null);
                    }

                    if (data.machine_type == '4') {
                        error_type_array.push([
                            ["상태", "불량유형"],
                            [data.ng1_label, data.ng1_count ?? 0],
                            [data.ng2_label, data.ng2_count ?? 0],
                            [data.ng3_label, data.ng3_count ?? 0],
                        ]);
                    } else {
                        error_type_array.push(null);
                    }
                }
            }

            // 3) 1차 상태 반영
            setStatusPie(status_array);
            setErrorPie(error_array);
            setErrorTypePie(error_type_array);
            setMachine(machineInfo);

            // 4) type=1 설비 없으면 하위 API 스킵/초기화
            if (!hasType1) {
                setProjectPie([]);
                setAutPie([]);
                setRunPie([]);
                setMachineReady('Y');
                return;
            }

            // 5) type=1 있을 때만 병렬 호출
            const [projRes, autRes, runRes] = await Promise.all([
                axios.get('/api/p/MachineMonitoring/SelectProjectName'),
                axios.get('/api/p/MachineMonitoring/SelectAutStatus'),
                axios.get('/api/p/MachineMonitoring/SelectRunStatus'),
            ]);

            // --- 프로젝트 파이 ---
            {
                const list = projRes?.data ?? [];
                let full_array = [];
                let temp_array = [];
                let data_machine_id = '0';

                for (let i = 0; i < list.length; i++) {
                    const d = list[i];
                    if (d.machine_id !== data_machine_id) {
                        full_array.push(temp_array);
                        data_machine_id = d.machine_id;
                        temp_array = [["비율", "프로젝트"]];
                    }
                    temp_array = temp_array.concat([[d.project_name, d.sum_produce_count]]);
                }
                full_array.push(temp_array);
                full_array.splice(0, 1);
                setProjectPie(full_array);
            }

            // --- 가동모드 파이 ---
            {
                const list = autRes?.data ?? [];
                let MDI = 0, EDIT = 0, HND = 0, JOG = 0, REF = 0, MEM = 0, ETC = 0;
                let full_array = [];
                let data_machine_id = '0';

                for (let i = 0; i < list.length; i++) {
                    const d = list[i];
                    if (d.machine_id !== data_machine_id) {
                        if (data_machine_id !== '0') {
                            full_array.push([
                            ["비율", "가동모드"],
                            ["MDI", MDI], ["MEM", MEM], ["EDIT", EDIT],
                            ["HND", HND], ["JOG", JOG], ["REF", REF], ["ETC", ETC],
                            ]);
                        }
                        data_machine_id = d.machine_id;
                        MDI = EDIT = HND = JOG = REF = MEM = ETC = 0;
                    }

                    if (d.status_aut === '0') MDI = d.sum_produce_time;
                    else if (['10','2','6','7','8'].includes(d.status_aut)) ETC += d.sum_produce_time;
                    else if (d.status_aut === '3') EDIT = d.sum_produce_time;
                    else if (d.status_aut === '4') HND = d.sum_produce_time;
                    else if (d.status_aut === '5') JOG = d.sum_produce_time;
                    else if (d.status_aut === '9') REF = d.sum_produce_time;
                    else if (d.status_aut === '1') MEM = d.sum_produce_time;
                }

                full_array.push([
                    ["비율", "가동모드"],
                    ["MDI", MDI], ["MEM", MEM], ["EDIT", EDIT],
                    ["HND", HND], ["JOG", JOG], ["REF", REF], ["ETC", ETC],
                ]);
                setAutPie(full_array);
                setMachineReady('Y');
            }

            // --- 가동상태 파이 ---
            {
                const list = runRes?.data ?? [];
                let reset = 0, stop = 0, hold = 0, start = 0, mstr = 0;
                let full_array = [];
                let data_machine_id = '0';

                for (let i = 0; i < list.length; i++) {
                    const d = list[i];
                    if (d.machine_id !== data_machine_id) {
                        if (data_machine_id !== '0') {
                            full_array.push([
                            ["상태", "가동상태"],
                            ["가동", start], ["정지", stop], ["홀드", hold],
                            ["MSTR", mstr],         // MSRT 오타 방지
                            ["오프라인", reset],
                            ]);
                        }
                        data_machine_id = d.machine_id;
                        reset = stop = hold = start = mstr = 0;
                    }

                    if (d.status_run === '0') reset = d.sum_produce_time;
                    else if (d.status_run === '1') stop = d.sum_produce_time;
                    else if (d.status_run === '2') hold = d.sum_produce_time;
                    else if (d.status_run === '3') start = d.sum_produce_time;
                    else if (d.status_run === '4') mstr = d.sum_produce_time;
                }

                full_array.push([
                    ["상태", "가동상태"],
                    ["가동", start], ["정지", stop], ["홀드", hold],
                    ["MSTR", mstr],
                    ["오프라인", reset],
                ]);
                setRunPie(full_array);
            }
        } catch (e) {
            try { appStore?.capture?.(e); } catch {}
            console.error(e);
        }
    };
    
    const CommonSearch = () => {
        axios.get('/api/Common/Main')
        .then((response) => {
            let stockArray = response.data.map((item, index) => ({
                id: item.item_id,
                item_data: item.item_name + ' ' +appStore.ITEM_FULL_SPEC_MAKE( item.item_spec, item.item_width, item.item_depth, item.item_height),
                dp_stock: item.dp_stock,
                dp_use_stock: item.dp_use_stock
            }));
            stockArray = stockArray.filter((item, index) => {
                return typeof item.id !== 'undefined';
            });

            let orderArray = response.data.map((item, index) => ({
                id: item.order_id,
                order_data: item.order_data
            }));
            orderArray = orderArray.filter((item, index) => {
                return typeof item.id !== 'undefined' && item.id !== 0;
            });

            let purchaseArray = response.data.map((item, index) => ({
                id: item.purchase_id,
                purchase_data: item.purchase_data
            }));
            purchaseArray = purchaseArray.filter((item, index) => {
                return typeof item.id !== 'undefined' && item.id !== 0;
            });

            let incomingArray = response.data.map((item, index) => ({
                id: item.incoming_id,
                incoming_data: item.incoming_data
            }));
            incomingArray = incomingArray.filter((item, index) => {
                return typeof item.id !== 'undefined' && item.id !== 0;
            });

            let outgoingArray = response.data.map((item, index) => ({
                id: item.outgoing_id,
                outgoing_data: item.outgoing_data
            }));
            outgoingArray = outgoingArray.filter((item, index) => {
                return typeof item.id !== 'undefined' && item.id !== 0;
            });

            let qualityMeasurementArray = response.data.map((item, index) => ({
                id: item.quality_measurement_id,
                quality_measurement_data: item.quality_measurement_data + ' / ' + (typeof item.quality_measurement_value === 'undefined'?item.quality_measurement_option_name:item.quality_measurement_value)  + ' (' + item.quality_measurement_result + ') / ' + item.quality_measurement_user_name
            }));
            qualityMeasurementArray = qualityMeasurementArray.filter((item, index) => {
                return typeof item.id !== 'undefined' && item.id !== 0;
            });
            
            setRowOrder(orderArray);
            setRowPurchase(purchaseArray);
            setRowIncoming(incomingArray);
            setRowOutgoing(outgoingArray);
            setRowQualityMeasurement(qualityMeasurementArray);
            setRowStock(stockArray);
        })
        .catch(function (error) {
        });
    };

    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
            .google-visualization-tooltip {
            max-width: none !important;   /* 기본 400px 제한 해제 */
            width: 250px !important;       /* 원하는 너비로 */
            white-space: normal;           /* 줄바꿈 허용 (가로 고정 늘리고 싶으면 'nowrap') */
            }
        `;
        document.head.appendChild(style);
        return () => document.head.removeChild(style);
    }, []);

    useEffect(() => {
        appStore.setLoading(false);

        // 비동기 통신이 완전히 끝난 후 로딩바를 끄도록 안전하게 구조 변경
        const fetchData = async () => {
            appStore.setLoading(true);
            try {
                await MainSearch(); // 데이터 가져올 때까지 대기
                CommonSearch();
            } finally {
                appStore.setLoading(false); // 완료 후 확실하게 로딩바 종료
            }
        };

        fetchData();

        // 🔄 30초마다 MainSearch 실행
        const interval = setInterval(() => {
            MainSearch();
        }, 30000);

        // 언마운트 시 정리
        return () => clearInterval(interval);
    }, []);
    
    return (
        <div style={{ width: '100vw', minHeight: 'auto', background: 'var(--bg)', padding: 0, margin: 0, position: 'relative' }}>
            {mainScreenType === '1'?
            <>
            <div className={styles.bigCardGrid}>
                {machine.map((item, index) => (
                    <div key={index} className={`${styles.card} ${styles.bigCard} card`}>
                        <div style={{ flex: 1, width: '100%' }}>
                            
                            {/* 🚨 TYPE 5일 때만 전체 높이 230px 고정 및 세로 Flex 레이아웃 적용 (다른 타입 코드 완벽 보존) */}
                            <div style={{
                                float: 'left', 
                                border: '3px solid #bdbdbd',  
                                width: '550px',
                                height: item.machine_type == '5' ? '230px' : 'auto',
                                display: item.machine_type == '5' ? 'flex' : 'block',
                                flexDirection: item.machine_type == '5' ? 'column' : 'unset'
                            }}>
                                <div style={{ height: '36px', backgroundColor: `${item.run_color}`, padding: '3px', flexShrink: item.machine_type == '5' ? 0 : undefined }}>
                                    <div style={{float: 'left', fontWeight: 'bold', fontSize: '22px', color: 'white'}}>
                                        {item.machine_name}
                                    </div>
                                    <div style={{float: 'right', fontWeight: 'bold', fontSize: '18px', color: 'white', paddingTop: '5px'}}>
                                        {item.project_name?.trim() ? item.project_name : item.run_status + ' [ '+item.machine_max_datetime+' ]' }
                                    </div>
                                </div>
                                {(item.machine_type == '1' && item.target_count > 0 && item.sum_produce_count > 0)?
                                <>
                                {/* 진행바 + 퍼센트 for type1 */}
                                <div className="progress-row" style={{ flexShrink: item.machine_type == '5' ? 0 : undefined }}>
                                    <div className="progress-shell">
                                        <div className="progress-track">
                                            <i style={{ width: `${item.progress_percent}%`, background: item.progress_percent_color }} />
                                        </div>
                                    </div>
                                    <div className="progress-label">
                                        {item.progress_percent}%
                                    </div>
                                </div>
                                </>
                                :
                                (item.machine_type == '4' && item.target_count > 0 && item.sum_produce_count > 0)?
                                <>
                                {/* 생산 카운트 for type4 only */}
                                <div style={{ height: '30px', padding: '5px', textAlign: 'center', fontWeight: 'bold', fontSize: '20px', flexShrink: item.machine_type == '5' ? 0 : undefined }}>
                                    <span>{Number(item.sum_produce_count).toLocaleString()} / {Number(item.target_count).toLocaleString()}</span>
                                </div>

                                {/* 진행바 + 퍼센트 for type4 */}
                                <div className="progress-row" style={{ flexShrink: item.machine_type == '5' ? 0 : undefined }}>
                                    <div className="progress-shell">
                                        <div className="progress-track">
                                            <i style={{ width: `${item.progress_percent}%`, background: item.progress_percent_color }} />
                                        </div>
                                    </div>
                                    <div className="progress-label">
                                        {item.progress_percent}%
                                    </div>
                                </div>
                                </>
                                :
                                <>
                                {item.machine_type == '5' ?
                                /* 🚨 TYPE 5 핵심: 하단 데이터의 줄 수(ROW)를 판별하여 뱃지 높이와 글자 크기를 비례적으로 자동 조절 */
                                (() => {
                                    const validCount = [1, 2, 3, 4, 5, 6, 7, 8, 9]
                                        .filter(num => item[`val${num}_name`] || (item[`val${num}`] !== null && item[`val${num}`] !== undefined)).length;
                                    const rowCount = Math.ceil(validCount / 3) || 1;
                                    
                                    const dynHeight = rowCount === 1 ? '85px' : (rowCount === 2 ? '60px' : '45px');
                                    const dynFontSize = rowCount === 1 ? '38px' : (rowCount === 2 ? '28px' : '20px');

                                    return (
                                        <div style={{ flex: 1, padding: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <span className={`badge ${
                                                item.run_status === "가동"   ? "run" :
                                                item.run_status === "정지"     ? "stop" :
                                                item.run_status === "홀드"     ? "hold" :
                                                item.run_status === "오프라인" ? "offline" :
                                                item.run_status === "MSTR"    ? "mstr" :
                                                item.run_status === "미 연결"    ? "notconnect" :
                                                "etc"
                                            }`} style={{ width: '300px', height: dynHeight, fontSize: dynFontSize, fontWeight: '900', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '30px' }}>
                                                {item.run_status}
                                            </span>
                                        </div>
                                    );
                                })()
                                : item.machine_type == '2'?
                                <div style={ { height: '146px', padding: '3px', textAlign:'center', fontWeight: 'bold', paddingTop: '25px' } }>
                                    <span className={`badge ${
                                        item.run_status === "가동"   ? "run" :
                                        item.run_status === "정지"     ? "stop" :
                                        item.run_status === "홀드"     ? "hold" :
                                        item.run_status === "오프라인" ? "offline" :
                                        item.run_status === "MSTR"    ? "mstr" :
                                        item.run_status === "미 연결"    ? "notconnect" :
                                        "etc"
                                    }`} style={ { width: '300px', height: '100px', fontSize: '58px' } }>
                                        {item.run_status}
                                    </span>
                                </div>
                                : item.machine_type == '1' ?
                                null
                                :
                                <div style={ { height: '70px', padding: '3px', textAlign:'center', fontWeight: 'bold', paddingTop: '8px' } }>
                                    <span className={`badge ${
                                        item.run_status === "가동"   ? "run" :
                                        item.run_status === "정지"     ? "stop" :
                                        item.run_status === "홀드"     ? "hold" :
                                        item.run_status === "오프라인" ? "offline" :
                                        item.run_status === "MSTR"    ? "mstr" :
                                        item.run_status === "미 연결"    ? "notconnect" :
                                        "etc"
                                    }`} style={ { width: '300px', height: '55px', fontSize: '32px' } }>
                                        {item.run_status}
                                    </span>
                                </div>}
                                </>
                                }
                                
                                <div style={{ textAlign:'center', padding: '3px', paddingTop: '3px', flexShrink: item.machine_type == '5' ? 0 : undefined }}>
                                    {(item.machine_type == '1')?
                                    <table className="machine-table">
                                        <colgroup>
                                            <col style={{width: '25%'}} />
                                            <col style={{width: '20%'}} />
                                            <col style={{width: '25%'}} />
                                            <col style={{width: '30%'}} />
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <td className="label" style={{ fontSize: '0.9em' }}>가동상태</td>
                                                <td className="value" style={{padding: '0'}}>
                                                    <span className={`badge ${
                                                        item.run_status === "가동"   ? "run" :
                                                        item.run_status === "정지"     ? "stop" :
                                                        item.run_status === "홀드"     ? "hold" :
                                                        item.run_status === "오프라인" ? "offline" :
                                                        item.run_status === "MSTR"    ? "mstr" :
                                                        item.run_status === "미 연결"    ? "notconnect" :
                                                        "etc"
                                                    }`}>{item.run_status}</span>
                                                </td>
                                                <td className="label" style={{ fontSize: '0.9em' }}>가공모드</td>
                                                <td className="value" style={{padding: '0'}}>
                                                    <span className={`badge ${
                                                        item.aut_status === "MDI"  ? "mdi" :
                                                        item.aut_status === "MEM"  ? "mem" :
                                                        item.aut_status === "EDIT" ? "edit" :
                                                        item.aut_status === "HND"  ? "hnd" :
                                                        item.aut_status === "JOG"  ? "jog" :
                                                        item.aut_status === "REF"  ? "ref" :
                                                        item.aut_status === "ETC"  ? "etc-mode" :
                                                        item.aut_status === "미 연결"   ? "notconnect" :
                                                        "etc-mode"
                                                    }`}>{item.aut_status}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="label" style={{ fontSize: '0.9em' }}>{`금일 가공 수량`}</td>
                                                <td className="value num">{item.sum_produce_count}</td>
                                                <td className="label" style={{ fontSize: '0.9em' }}>{`금일 가공 시간`}</td>
                                                <td className="value">{formatTime(item.sum_produce_time)}</td>
                                            </tr>
                                            <tr>
                                                <td className="label" style={{ fontSize: '0.9em' }}>소요부품수</td>
                                                <td className="value num">{item.raw_target_part}</td>
                                                <td className="label" style={{ fontSize: '0.9em' }}>가공부품수</td>
                                                <td className="value num">{item.raw_part}</td>
                                            </tr>
                                            <tr>
                                                <td className="label" style={{ fontSize: '0.9em' }}>가공부품전체수</td>
                                                <td className="value num">{item.raw_total_part}</td>
                                                <td className="label" style={{ fontSize: '0.9em' }}>운전시간</td>
                                                <td className="value">{formatTime(item.raw_run_time) || ''}</td>
                                                
                                            </tr>
                                        </tbody>
                                    </table>
                                    :
                                    (item.machine_type == '4')?
                                    <table className="machine-table" style={{ width: "100%" }}>
                                        <colgroup>
                                            {/* 1세트 */}
                                            <col style={{ width: "10%" }} />
                                            <col style={{ width: "10%" }} />
                                            <col style={{ width: "6.6667%" }} />
                                            <col style={{ width: "6.6667%" }} />

                                            {/* 2세트 */}
                                            <col style={{ width: "10%" }} />
                                            <col style={{ width: "10%" }} />
                                            <col style={{ width: "6.6667%" }} />
                                            <col style={{ width: "6.6667%" }} />
                                        </colgroup>
                                        <tbody>
                                            <tr style={ { height:'35px' } }>
                                                <td className="label" style={{ width: "125px", color: 'blue' }} colSpan={3}>OK</td>
                                                <td className="value num" style={{ width: "100px" }} colSpan={3}>{Number(item.sum_ok_count).toLocaleString()}</td>
                                                <td className="label" style={{ width: "125px", color: 'red' }} colSpan={3}>NG</td>
                                                <td className="value num" style={{ width: "100px" }} colSpan={3}>{Number(item.sum_ng_count).toLocaleString()}</td>
                                            </tr>
                                            <tr style={ { height:'39px' } }>
                                                <td className="label" style={{ width: "85px", fontSize: '14px', padding: '3px', fontWeight:'normal' }} colSpan={2}>{item.ng1_label}</td>
                                                <td className="value num" style={{ width: "65px", fontSize: '14px', padding: '3px', fontWeight:'normal' }} colSpan={2}>{item.ng1_count}</td>
                                                <td className="label" style={{ width: "85px", fontSize: '14px', padding: '3px', fontWeight:'normal' }} colSpan={2}>{item.ng2_label}</td>
                                                <td className="value num" style={{ width: "65px", fontSize: '14px', padding: '3px', fontWeight:'normal' }} colSpan={2}>{item.ng2_count}</td>
                                                <td className="label" style={{ width: "85px", fontSize: '14px', padding: '3px', fontWeight:'normal' }} colSpan={2}>{item.ng3_label}</td>
                                                <td className="value num" style={{ width: "65px", fontSize: '14px', padding: '3px', fontWeight:'normal' }} colSpan={2}>{item.ng3_count}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    :
                                    (item.machine_type == '5')?
                                    <div style={{ width: "100%" }}>
                                        {(() => {
                                            const validItems = [1, 2, 3, 4, 5, 6, 7, 8, 9]
                                                .map(num => ({
                                                    num,
                                                    name: item[`val${num}_name`],
                                                    val: item[`val${num}`]
                                                }))
                                                .filter(x => x.name || (x.val !== null && x.val !== undefined));

                                            if (validItems.length === 0) return null;

                                            const chunks = [];
                                            for (let i = 0; i < validItems.length; i += 3) {
                                                const chunk = validItems.slice(i, i + 3);
                                                while (chunk.length < 3) {
                                                    chunk.push({ num: '', name: '', val: '' });
                                                }
                                                chunks.push(chunk);
                                            }

                                            return chunks.map((chunk, rowIdx) => {
                                                return (
                                                    <table key={rowIdx} className="machine-table" style={{ width: "100%", borderTop: rowIdx > 0 ? 'none' : '2px solid #ddd', marginTop: rowIdx > 0 ? '-1px' : '0', marginBottom: 0 }}>
                                                        <colgroup>
                                                            <col style={{ width: "18%" }} />
                                                            <col style={{ width: "15%" }} />
                                                            <col style={{ width: "18%" }} />
                                                            <col style={{ width: "15%" }} />
                                                            <col style={{ width: "18%" }} />
                                                            <col style={{ width: "15%" }} />
                                                        </colgroup>
                                                        <tbody>
                                                            <tr style={ { height:'39px' } }>
                                                                {chunk.map((c, cIdx) => (
                                                                    <Fragment key={cIdx}>
                                                                        <td className="label" style={{ fontSize: '14px', padding: '3px', fontWeight:'normal' }}>
                                                                            {c.name || ''}
                                                                        </td>
                                                                        <td className="value num" style={{ fontSize: '16px', padding: '3px', fontWeight:'bold', color: '#111' }}>
                                                                            {c.val !== undefined && c.val !== null && c.val !== '' ? c.val : ''}
                                                                        </td>
                                                                    </Fragment>
                                                                ))}
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                );
                                            });
                                        })()}
                                    </div>
                                    :
                                    <></>
                                    }
                                </div>
                            </div>
                            {(item.machine_type == '1')?
                            <div className={styles.hideOnSmall} style={{display:'flex', height:item.progress_percent==0?'200px':'250px', marginLeft:'10px'}}>
                                <div className={styles.pieChart1} style={{float: 'left', width: '380px', height: item.progress_percent==0?'200px':'250px', marginLeft:'10px'}}>
                                    {machineReady === 'Y'?
                                    <div style={{ width: '100%', height: item.progress_percent==0?'190px':'240px' }}>
                                        <Chart
                                            chartType="PieChart"
                                            data={runPie[index]}
                                            options={runPie_option}
                                            width={"100%"}
                                            height={item.progress_percent==0?'190px':'240px'}
                                        />
                                    </div>
                                    :''}
                                </div>
                                <div className={styles.pieChart2} style={{float: 'left',  width: '380px', height: item.progress_percent==0?'200px':'250px', marginLeft:'10px'}}>
                                    {machineReady === 'Y'?
                                    <div style={{ width: '100%', height: item.progress_percent==0?'190px':'240px' }}>
                                        <Chart
                                            chartType="PieChart"
                                            data={autPie[index]}
                                            options={autPie_option}
                                            width={"100%"}
                                            height={item.progress_percent==0?'190px':'240px'}
                                        />
                                    </div>
                                    :''}
                                </div>
                                <div className={styles.pieChart3} style={{float: 'left',  width: '380px', height: item.progress_percent==0?'200px':'250px', marginLeft:'10px'}}>
                                    {machineReady === 'Y'?
                                    <div style={{ width: '100%', height: item.progress_percent==0?'190px':'240px' }}>
                                        <Chart
                                            chartType="PieChart"
                                            data={projectPie[index]}
                                            options={projectPie_option}
                                            width={"100%"}
                                            height={item.progress_percent==0?'190px':'240px'}
                                        />
                                    </div>
                                    :''}
                                </div>
                            </div>
                            :
                            (item.machine_type == '2' || item.machine_type == '4')?
                            <div className={styles.hideOnSmall} style={{display:'flex', height: item.progress_percent==0?'200px':'250px', marginLeft:'10px'}}>
                                <div className={styles.pieChart1} style={{float: 'left',  width: '380px', height: item.progress_percent==0?'200px':'250px', marginLeft:'10px'}}>
                                    {machineReady === 'Y'?
                                    <div style={{ width: '100%', height: '240px' }}>
                                        <Chart
                                            chartType="PieChart"
                                            data={statusPie[index]}
                                            options={statusPie_option}
                                            width={"100%"}
                                            height={item.progress_percent==0?'190px':'240px'}
                                        />
                                    </div>
                                    :''}
                                </div>
                                {item.machine_type == '2'?
                                <>
                                <div className={styles.pieChart2} style={{float: 'left',  width: '770px', height: item.progress_percent==0?'200px':'250px', marginLeft:'10px'}}>
                                    <p style={ { fontSize:'18px', fontWeight:'bold', padding:'0px', marginTop:'5px' } }>
                                        가동시간
                                    </p>
                                    <div style={{ paddingTop:'15px' }}>
                                        <Chart
                                            chartType="Timeline"
                                            data={timeLineData}
                                            options={timeLineOption}
                                            width="100%"
                                            height={item.progress_percent==0?'190px':'240px'}
                                        />
                                    </div>
                                </div>
                                </>
                                :
                                <>
                                <div className={styles.pieChart2} style={{float: 'left',  width: '380px', height: item.progress_percent==0?'200px':'250px', marginLeft:'10px'}}>
                                    {machineReady === 'Y'?
                                    <div style={{ width: '100%', height: item.progress_percent==0?'190px':'240px' }}>
                                        <Chart
                                            chartType="PieChart"
                                            data={errorPie[index]}
                                            options={errorPie_option}
                                            width={"100%"}
                                            height={item.progress_percent==0?'190px':'240px'}
                                        />
                                    </div>
                                    :''}
                                </div>
                                <div className={styles.pieChart3} style={{float: 'left',  width: '380px', height: item.progress_percent==0?'200px':'250px', marginLeft:'10px'}}>
                                    {machineReady === 'Y'?
                                    <div style={{ width: '100%', height: item.progress_percent==0?'190px':'240px' }}>
                                        <Chart
                                            chartType="PieChart"
                                            data={errorTypePie[index]}
                                            options={errorTypePie_option}
                                            width={"100%"}
                                            height={item.progress_percent==0?'190px':'240px'}
                                        />
                                    </div>
                                    :''}
                                </div>
                                </>}
                            </div>
                            :
                            (item.machine_type == '5')?
                            /* 🚨 TYPE 5 전용 오른쪽 차트 영역 (파이 1칸의 글자 '가동상태' 타이틀 제거 완료!) */
                            <div className={styles.hideOnSmall} style={{display:'flex', height: '230px', marginLeft:'10px'}}>
                                {/* 1. 가동상태 파이차트 (상단 글자 타이틀을 제거하고 높이를 210px로 꽉 채움) */}
                                <div className={styles.pieChart1} style={{float: 'left', width: '380px', height: '230px', marginLeft:'10px'}}>
                                    {machineReady === 'Y'?
                                    <div style={{ width: '100%', height: '210px', paddingTop: '10px' }}>
                                        <Chart
                                            chartType="PieChart"
                                            data={
                                                (item.run_min || item.stop_min) ? [
                                                    ["상태", "비율"],
                                                    ["가동", Number(item.run_min ?? 0)],
                                                    ["정지", Number(item.stop_min ?? 0)]
                                                ] : [
                                                    ["상태", "비율"],
                                                    ["가동", item.run_status === "가동" ? 1 : 0],
                                                    ["정지", item.run_status === "정지" ? 1 : 0]
                                                ]
                                            }
                                            options={statusPie_option} 
                                            width={"100%"}
                                            height={"100%"}
                                        />
                                    </div>
                                    :''}
                                </div>
                                
                                {/* 2. 최근 30분 꺾은선 그래프 */}
                                <div className={styles.pieChart2} style={{float: 'left', width: '770px', height: '230px', marginLeft:'10px'}}>
                                    <p style={{ fontSize:'18px', fontWeight:'bold', padding:'0px', marginTop:'10px', textAlign:'center' }}>최근 30분 데이터</p>
                                    {machineReady === 'Y'?
                                    <div style={{ width: '100%', height: '170px' }}>
                                        {modbusLineData[item.machine_id] && modbusLineData[item.machine_id].length > 1 ? (
                                            <Chart
                                                chartType="LineChart"
                                                data={modbusLineData[item.machine_id]}
                                                options={{
                                                    curveType: "function",
                                                    legend: { position: "bottom" },
                                                    chartArea: { width: '90%', height: '70%' },
                                                    vAxis: { minValue: 0 },
                                                    pointSize: 4
                                                }}
                                                width="100%"
                                                height="100%"
                                            />
                                        ) : (
                                            <div style={{ display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center', color: '#999', fontSize: '18px', fontWeight: 'bold' }}>
                                                수집된 데이터가 없습니다.
                                            </div>
                                        )}
                                    </div>
                                    :''}
                                </div>
                            </div>
                            :<></>}
                        </div>
                    </div>
                ))}
            </div>
            </>
            :
            <></>
            }
            {/* 아래 기존 6개 카드뉴스 */}
            <div className={styles.smallCardGrid}>
                <div className={`${styles.card} ${styles.smallCard} card`}>
                    <h2 className={styles.smallCardTitle}>품목재고</h2>
                    <div style={{ flex: 1, width: '100%' }}>
                        <DataGrid
                            rows={rowStock}
                            columns={columnStock}
                            rowHeight={52}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            initialState={{ 
                                density: 'compact',
                                pagination: {
                                    paginationModel: { pageSize: 5, page: 0 },
                                },
                            }}
                            columnVisibilityModel={{id: false}}              
                            sx={{
                                height: '100%',
                                '& .MuiDataGrid-columnHeaderTitle': {
                                  fontSize: '17px',
                                  fontWeight: 'bold'
                                }
                            }}
                        />
                    </div>
                </div>
                <div className={`${styles.card} ${styles.smallCard}`}>
                    <h2 className={styles.smallCardTitle}>수주정보</h2>
                    <div style={{ flex: 1, width: '100%' }}>
                        <DataGrid
                            rows={rowOrder}
                            columns={columnOrder}
                            rowHeight={52}
                            onRowClick={handleRowClick('order')}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            initialState={{ 
                                density: 'compact',
                                pagination: {
                                    paginationModel: { pageSize: 5, page: 0 },
                                },
                            }}
                            columnVisibilityModel={{id: false}}              
                            sx={{
                                height: '100%',
                                '& .MuiDataGrid-columnHeaderTitle': {
                                  fontSize: '17px',
                                  fontWeight: 'bold'
                                },
                                '& .MuiDataGrid-row': {
                                  cursor: 'pointer'
                                }
                            }}
                        />
                    </div>
                </div>
                <div className={`${styles.card} ${styles.smallCard}`}>
                    <h2 className={styles.smallCardTitle}>발주정보</h2>
                    <div style={{ flex: 1, width: '100%' }}>
                        <DataGrid
                            rows={rowPurchase}
                            columns={columnPurchase}
                            rowHeight={52}
                            onRowClick={handleRowClick('purchase')}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            initialState={{ 
                                density: 'compact',
                                pagination: {
                                    paginationModel: { pageSize: 5, page: 0 },
                                },
                            }}
                            columnVisibilityModel={{id: false}}              
                            sx={{
                                height: '100%',
                                '& .MuiDataGrid-columnHeaderTitle': {
                                  fontSize: '17px',
                                  fontWeight: 'bold'
                                },
                                '& .MuiDataGrid-row': {
                                  cursor: 'pointer'
                                }
                            }}
                        />
                    </div>
                </div>
                <div className={`${styles.card} ${styles.smallCard}`}>
                    <h2 className={styles.smallCardTitle}>입고정보</h2>
                    <div style={{ flex: 1, width: '100%' }}>
                        <DataGrid
                            rows={rowIncoming}
                            columns={columnIncoming}
                            rowHeight={52}
                            onRowClick={handleRowClick('incoming')}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            initialState={{ 
                                density: 'compact',
                                pagination: {
                                    paginationModel: { pageSize: 5, page: 0 },
                                },
                            }}
                            columnVisibilityModel={{id: false}}              
                            sx={{
                                height: '100%',
                                '& .MuiDataGrid-columnHeaderTitle': {
                                  fontSize: '17px',
                                  fontWeight: 'bold'
                                },
                                '& .MuiDataGrid-row': {
                                  cursor: 'pointer'
                                }
                            }}
                        />
                    </div>
                </div>
                <div className={`${styles.card} ${styles.smallCard}`}>
                    <h2 className={styles.smallCardTitle}>출하정보</h2>
                    <div style={{ flex: 1, width: '100%' }}>
                        <DataGrid
                            rows={rowOutgoing}
                            columns={columnOutgoing}
                            rowHeight={52}
                            onRowClick={handleRowClick('outgoing')}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            initialState={{ 
                                density: 'compact',
                                pagination: {
                                    paginationModel: { pageSize: 5, page: 0 },
                                },
                            }}
                            columnVisibilityModel={{id: false}}              
                            sx={{
                                height: '100%',
                                '& .MuiDataGrid-columnHeaderTitle': {
                                  fontSize: '17px',
                                  fontWeight: 'bold'
                                },
                                '& .MuiDataGrid-row': {
                                  cursor: 'pointer'
                                }
                            }}
                        />
                    </div>
                </div>
                <div className={`${styles.card} ${styles.smallCard}`}>
                    <h2 className={styles.smallCardTitle}>품질측정정보</h2>
                    <div style={{ flex: 1, width: '100%' }}>
                        <DataGrid
                            rows={rowQualityMeasurement}
                            columns={columnQualityMeasurement}
                            rowHeight={52}
                            onRowClick={handleRowClick('quality_measurement')}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            initialState={{ 
                                density: 'compact',
                                pagination: {
                                    paginationModel: { pageSize: 5, page: 0 },
                                },
                            }}
                            columnVisibilityModel={{id: false}}              
                            sx={{
                                height: '100%',
                                '& .MuiDataGrid-columnHeaderTitle': {
                                  fontSize: '17px',
                                  fontWeight: 'bold'
                                },
                                '& .MuiDataGrid-row': {
                                  cursor: 'pointer'
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Main;
